export default [
    {
        id: 1,
        name: 'UTR Tournament',
        club: {
            id: 5,
            name: 'club4',
        },
        photoUrl: null,
        details: 'Lorem ipsum bla bla',
        eventSchedule: {
            eventStartDate: '22',
            eventEndDate: '29',
            eventStartMonth: 'May',
            eventEndMonth: 'May',
        },
        published: false,
        registeredCount: 0,
        eventLocations: [
            {
                eventLocationType: {
                    id: 1,
                    value: 'primary',
                    label: 'Primary',
                    description: 'This is the main location for the event.',
                },
                locationId: 7423,
                locationLat: 37.7610051,
                locationLng: -122.42717070000003,
                locationStreetAddress: '3753 18th St',
                locationCityStateZip: 'San Francisco, CA 94114',
                locationPlaceName: 'Mission Dolores Park Tennis Courts',
                location: '3753 18th St, San Francisco, CA 94114, USA',
            },
        ],
        eventState: {
            id: 3,
            label: 'Registration Closed',
            value: 'registration_closed',
            description: '',
        },
        utrType: {
            value: 'sanctioned',
        },
        currentMember: {},
    },
    {
        id: 2,
        name: 'UTR Tournament',
        club: {
            id: 5,
            name: 'club4',
        },
        photoUrl: null,
        details: 'Lorem ipsum bla bla',
        eventSchedule: {
            eventStartDate: '22',
            eventEndDate: '29',
            eventStartMonth: 'May',
            eventEndMonth: 'May',
        },
        published: false,
        registeredCount: 0,
        eventLocations: [
            {
                eventLocationType: {
                    id: 1,
                    value: 'primary',
                    label: 'Primary',
                    description: 'This is the main location for the event.',
                },
                locationId: 7423,
                locationLat: 37.7610051,
                locationLng: -122.42717070000003,
                locationStreetAddress: '3753 18th St',
                locationCityStateZip: 'San Francisco, CA 94114',
                locationPlaceName: 'Mission Dolores Park Tennis Courts',
                location: '3753 18th St, San Francisco, CA 94114, USA',
            },
        ],
        eventState: {
            id: 3,
            label: 'Registration Closed',
            value: 'registration_closed',
            description: '',
        },
        utrType: {
            value: 'sanctioned',
        },
        currentMember: {},
    },
];
